import { apiRequest, refreshSession } from "./apiClient";

export async function login(username, password) {
  return apiRequest("/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  }, { skipAuthRetry: true });
}

export async function autologin() {
  return apiRequest("/auth/autologin", {
    method: "POST",
  }, { skipAuthRetry: true });
}

export async function refreshToken() {
  return refreshSession();
}

export async function logout() {
  return apiRequest("/auth/logout", {
    method: "POST",
  }, { skipAuthRetry: true });
}
